import React from "react";
import "./about.css"
import Me from '../../outerComponents/Me.jpg'
import { Slide } from "react-awesome-reveal";
import resume from '../../outerComponents/Pritam_Halder.pdf'
const About = () => {
  return (<div id="about" className="about section">
    <br />
    <h2 style={{ textAlign: "center", color: "#01be96" }}>About Me</h2>
    <div className="nav-link about">
      <div className="Container">
        <Slide direction="left">
          <div className="Texts">
            <h3>Full Stack Web Developer(MERN)</h3>
            <p id="user-detail-intro">
            Highly motivated and skilled Full Stack Web Developer with expertise in MERN stack and a proven track record of building dynamic and responsive web applications. Adept at prompt engineering, collaborating in cross-functional teams, and delivering high-quality projects. Possesses a strong foundation in data structures and algorithms with 1200+ hours of coding and 600+ DSA solutions. Excited to leverage Generative AI and quickly learn new tech stacks to drive innovation and exceed development goals.
            </p>
            <br />
            <p>150+ Assignment Problem solve</p>
            <p>11+ Projects Completed</p>
            <br />
            <div style={{ display: "flex", gap: "3%" }}>
              <div className="nav-link resume" id="resume-button-2">
                <a href={resume} id="resume-link-2" className='btn' target='_blank' download="Pritam-Halder-Resume" onClick={() =>
                  window.open(
                    "https://drive.google.com/file/d/1DLS0HqF4MBcsZOehqQHw7tvzjIGcAfl1/view?usp=sharing"
                  )
                }>Download Resume</a>
              </div>
              <a href="#contact" className='btn btn-primary'>Contact</a>
            </div>
          </div>
        </Slide>
        <Slide direction="right">
          <div className="about_me Profile ">
            <div className='about_me-image'>
              <img className="home-img" src={Me} alt="" />
            </div>
          </div>
        </Slide>
      </div>
    </div>
  </div>
  );
};

export default About;